import React from "react";

const About = () => {
   return (
      <h1>
          Обучающее приложения с канала ULBI TV
      </h1>
   )
}

export default About;